import { ChatUser, ChatUserResource } from '@/entities/ChatUser/ChatUser'
import { transformToChatUser } from '@/entities/ChatUser/ChatUserTransformers'
import { FetchCollectionResult, FetchResultType } from '@/entities/FetchResult'
import { authorizedFetch } from '@/helpers/authorizedFetch'
import { trans } from '@/helpers/trans'
import { generateApiV3Url } from '@/helpers/url'

export const getChatUsersApiCall = async (): Promise<FetchCollectionResult<ChatUser[], string>> => {
    try {
        const url = generateApiV3Url({ endpoint: '/users/profile/me/chat-users' })
        const response = await authorizedFetch(url)

        if (! response.ok) {
            return {
                status: response.status,
                type: FetchResultType.Error,
                error: trans('errors.unknownError'),
            }
        }

        const resources: ChatUserResource[] = await response.json()

        return {
            amountOfPages: 1,
            status: response.status,
            type: FetchResultType.Success,
            data: resources.map(transformToChatUser),
        }
    } catch (error) {
        console.error('[getChatUsersApiCall]', error)

        return {
            status: 500,
            type: FetchResultType.Error,
            error: trans('errors.unknownError'),
        }
    }
}
